import { useEffect, useState } from "react";

export function useValorDebounced<T>(valor: T, esperaMs: number): T {
  const [debounced, definir] = useState(valor);
  useEffect(() => {
    const timer = window.setTimeout(() => definir(valor), esperaMs);
    return () => window.clearTimeout(timer);
  }, [valor, esperaMs]);
  return debounced;
}
